import { render } from "./GameroomError.vue?vue&type=template&id=0360127c&scoped=true"
import script from "./GameroomError.vue?vue&type=script&lang=js"
export * from "./GameroomError.vue?vue&type=script&lang=js"

import "./GameroomError.vue?vue&type=style&index=0&id=0360127c&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0360127c"]])

export default __exports__